import { useState, useEffect } from 'react'
import { Navigation } from './components/navigation'
import { Header } from './components/header'
import { Features } from './components/features'
import { Testimonials } from './components/testimonials'
import { FAQ } from './components/faq'
import { Download } from './components/download'
import { Footer } from './components/footer'
import { Contact } from './components/contact'
import { About } from './components/about'
import { Gallery } from './components/gallery'
import JsonDataEt from './data/data.json'
import JsonDataEn from './data/data-en.json'
import SmoothScroll from 'smooth-scroll'

export const scroll = new SmoothScroll('a[href*="#"]', {
  speed: 1000,
  speedAsDuration: true,
})

const App = () => {
  const [landingPageData, setLandingPageData] = useState({})
  const [language, setLanguage] = useState(() => {
    // Try to load language preference from localStorage
    const savedLanguage = localStorage.getItem('language');
    return savedLanguage || 'et'; // Default to Estonian if not set
  })
  
  useEffect(() => {
    // Load data based on selected language
    const data = language === 'et' ? JsonDataEt : JsonDataEn
    setLandingPageData(data)
    
    // Save language preference to localStorage
    localStorage.setItem('language', language);
    
    // Simple routing logic to handle the privacy policy path
    const path = window.location.pathname;
    if (path === '/privacy-policy') {
      // Redirect to the appropriate language version of the privacy policy
      window.location.href = language === 'et' 
        ? '/privacy_policy_et.html' 
        : '/privacy_policy.html';
    }
  }, [language]) // Re-run when language changes
  
  // Function to handle language change
  const handleLanguageChange = (lang) => {
    setLanguage(lang)
  }

  return (
    <div>
      <Navigation 
        data={landingPageData.Navigation} 
        currentLanguage={language} 
        onLanguageChange={handleLanguageChange} 
      />
      <Header data={landingPageData.Header} />
      <Features 
        data={landingPageData.Features}
        header={landingPageData.FeaturesHeader}
      />
      <Download data={landingPageData.Download} />
      <FAQ data={landingPageData.FAQ} />
      <About data={landingPageData.About} />
      <Gallery />
      <Testimonials 
        data={landingPageData.Testimonials}
        header={landingPageData.TestimonialsHeader}
      />
      <Contact data={landingPageData.Contact} />
      <Footer 
        data={landingPageData.Footer}
        currentLanguage={language} 
      />
    </div>
  )
}

export default App